/* AMLA · Luz Regia — packs, carrito, barra fija, fechas de entrega y cifras animadas. */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ───────────── Packs: 1 · 3 (paga 2) · 5 (paga 3). El descuento lo aplica la caja (BXGY automático). ───────────── */
  function packs(root) {
    var cards = $$('.am-pack', root), atc = $('.am-atc', root), msg = $('.am-atc__msg', root);
    var variant = parseInt(root.getAttribute('data-variant'), 10);
    function elegir(c) {
      cards.forEach(function (x) { x.classList.toggle('is-on', x === c); x.setAttribute('aria-checked', x === c ? 'true' : 'false'); });
    }
    cards.forEach(function (c) {
      c.addEventListener('click', function () { elegir(c); });
      c.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); elegir(c); } });
    });
    if (!atc) return;
    atc.addEventListener('click', function () {
      var sel = cards.filter(function (c) { return c.classList.contains('is-on'); })[0] || cards[0];
      var qty = parseInt(sel.getAttribute('data-units'), 10) || 1;
      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var body = { items: [{ id: variant, quantity: qty }] };
      if (cart && cart.getSectionsToRender) {
        body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname + window.location.search; // con ?_fd=0 / ?country= el render no redirige
      }
      if (msg) msg.textContent = '';
      atc.setAttribute('aria-busy', 'true');
      var url = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status && res.status !== 200) throw new Error(res.description || res.message || 'No se pudo agregar');
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'am-packs', cartData: res });
          }
          if (cart && cart.renderContents && res.sections) {
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            cart.renderContents(res);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(function (err) { if (msg) msg.textContent = err.message || 'No se pudo añadir el producto. Inténtalo de nuevo.'; })
        .finally(function () { atc.removeAttribute('aria-busy'); });
    });
  }

  /* ───────────── Fechas de entrega (mismo criterio que SuperCalm: de +5 a +9 días) ───────────── */
  function fechasEntrega() {
    var dias = ['dom.', 'lun.', 'mar.', 'mié.', 'jue.', 'vie.', 'sáb.'];
    var meses = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
    $$('[data-am-entrega]').forEach(function (e) {
      var d = new Date(); d.setDate(d.getDate() + parseInt(e.getAttribute('data-am-entrega'), 10));
      e.textContent = dias[d.getDay()] + ' ' + d.getDate() + ' de ' + meses[d.getMonth()];
    });
  }

  /* ───────────── Anclas suaves ───────────── */
  function anclas() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-am-goto]');
      if (!a) return;
      var t = document.querySelector(a.getAttribute('data-am-goto'));
      if (!t) return;
      e.preventDefault();
      window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - 90, behavior: 'smooth' });
    });
  }

  /* ───────────── Barra fija: aparece cuando los packs ya no se ven ───────────── */
  function barraFija() {
    var bar = $('.am-sticky'), packsEl = $('#am-packs');
    if (!bar || !packsEl || !('IntersectionObserver' in window)) return;
    document.body.appendChild(bar); // el content-visibility del tema encierra a los position:fixed
    var visible = true;
    function pintar() { bar.classList.toggle('is-on', !visible && window.scrollY > 500); }
    new IntersectionObserver(function (en) { visible = en[0].isIntersecting; pintar(); }, { threshold: 0 }).observe(packsEl);
    window.addEventListener('scroll', pintar, { passive: true });
  }

  /* ───────────── Cifras: cuentan al entrar en pantalla ───────────── */
  function cifras() {
    var els = $$('[data-am-cifra]');
    if (!els.length) return;
    var pais = (window.Shopify && window.Shopify.country) || 'MX';
    var loc = pais === 'MX' || pais === 'US' ? 'es-MX' : 'es-ES';
    function animar(el) {
      var fin = parseFloat(el.getAttribute('data-am-cifra')), pct = parseFloat(el.getAttribute('data-am-pct') || '100');
      var n = el.querySelector('[data-am-n]'), ring = el, t0 = null, dur = 1400;
      function paso(ts) {
        if (!t0) t0 = ts;
        var k = Math.min(1, (ts - t0) / dur), e = 1 - Math.pow(1 - k, 3);
        n.textContent = Math.round(fin * e).toLocaleString(loc);
        ring.style.setProperty('--p', (pct * e).toFixed(1));
        if (k < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(animar); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { animar(x.target); io.unobserve(x.target); } });
    }, { threshold: 0.4 });
    els.forEach(function (e) { io.observe(e); });
  }

  function init() {
    $$('[data-am-packs]').forEach(packs);
    fechasEntrega(); anclas(); barraFija(); cifras();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
